import { dynamicLoader } from '~/utils';

export const LookupsPage = dynamicLoader({
  name: 'LookupsPage',
  importFunc: () => import('./lookups'),
});